// *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** ***
// *** *** DO NOT MODIFY. THIS IS A GENERATED FILE...KITTENS COULD DIE *** ***
// *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** ***
export default {
  ACTION: {
    DRAW: {
      FILL:       'action.draw.fill',
      SUBSTITUTE: 'action.draw.place.substitute',
      RESELECT:   'action.draw.reselect',
      SELECT:     'action.draw.select',
      SHUFFLE:    'action.draw.shuffle',
    },
    DRAW_PLACE: {
      ARCHIVE:      'action.draw.place.archive',
      ASSIGN:       'action.draw.place.assign',
      CONFIRM:      'action.draw.place.confirm',
      INVALIDATE:   'action.draw.place.invalidate',
      UNINVALIDATE: 'action.draw.place.uninvalidate',
    },
  },
  AVATAR: {
    USER: {
      ARTEMIS:     'avatar.artemis',
      ATHENA:      'avatar.athena',
      CAT:         'avatar.cat',
      CUPCAKE:     'avatar.cupcake',
      DESPERADO:   'avatar.desperado',
      DINOSAUR:    'avatar.dinosaur',
      FLOWER:      'avatar.flower',
      GINGER:      'avatar.ginger',
      HAL:         'avatar.hal',
      HUMPHREY:    'avatar.humphrey',
      ICECREAM:    'avatar.icecream',
      LEGOBOT:     'avatar.legobot',
      MARMADUKE:   'avatar.marmaduke',
      MUSE:        'avatar.muse',
      NEMESIS:     'avatar.nemesis',
      OZZY:        'avatar.ozzy',
      PAPILLON:    'avatar.papillon',
      SENSUI:      'avatar.sensei',
      SHONOBI:     'avatar.shinobi',
      SNOWBOARDER: 'avatar.snowboarder',
      SNOWFLAKE:   'avatar.snowflake',
      SPARROW:     'avatar.sparrow',
      STACHE:      'avatar.stache',
      STAR:        'avatar.star',
      SYSTEM:      'avatar.system',
      UNICORN:     'avatar.unicorn',
      VENUS:       'avatar.venus',
      VROOM:       'avatar.vroom',
      WONDERWOMAN: 'avatar.wonderwoman',
      XCHT:        'avatar.x',
    },
  },
  CLASS: {
    ACCOUNT: {
      AGENCY:     'class.account.agency',
      BUSINESS:   'class.account.business',
      ENTERPRISE: 'class.account.enterprise',
      SME:        'class.account.sme',
    },
    ASSET_FILE:  { DOWNLOAD: 'class.asset.file.download' },
    ASSET_FORM:  { LOYALTY: 'class.asset.form.loyalty' },
    ASSET_IMAGE: {
      ASSET:      'class.asset.image.asset',
      BACKGROUND: 'class.asset.image.background',
      BANNER:     'class.asset.image.banner',
      COUPON:     'class.asset.image.coupon',
      HERO:       'class.asset.image.hero',
      IMAGE:      'class.asset.image.image',
      THUMBNAIL:  'class.asset.image.thumbnail',
    },
    CAMPAIGNOBJECT: {
      ACTIVATION:          'class.campaignobject.activation',
      ADVOCACY:            'class.campaignobject.advocacy',
      CLICK:               'class.campaignobject.click',
      CONTENT:             'class.campaignobject.content',
      CONTESTCAPTION:      'class.campaignobject.contest.ugc.caption',
      CONTESTFAVOURITE:    'class.campaignobject.contest.ugc.favourite',
      CONTESTVIDEO:        'class.campaignobject.contest.ugc.video',
      CONVERSATION:        'class.campaignobject.conversation',
      COUPONFLASH:         'class.campaignobject.coupon.flash',
      COUPONONLINE:        'class.campaignobject.coupon.online',
      COUPONPRINT:         'class.campaignobject.coupon.print',
      CUSTOM:              'class.campaignobject.custom',
      DOWNLOAD:            'class.campaignobject.download',
      GAME:                'class.campaignobject.game',
      LEAD:                'class.campaignobject.lead',
      LOYALTY:             'class.campaignobject.loyalty',
      OFFFER:              'class.campaignobject.offer',
      QUIZCATEGORY:        'class.campaignobject.quiz.category',
      QUIZQUICKFIRE:       'class.campaignobject.quiz.quickfire',
      QUIZSCORE:           'class.campaignobject.quiz.score',
      REFERRAL:            'class.campaignobject.referral',
      SIGNUPEVENT:         'class.campaignobject.signup.event',
      SIGNUPFEEDBACK:      'class.campaignobject.signup.feedback',
      SIGNUPPRODUCT:       'class.campaignobject.signup.product',
      SIGNUPREGISTRATION:  'class.campaignobject.signup.registration',
      SIGNUPSAMPLE:        'class.campaignobject.signup.sample',
      SWEEPSTAKEGIVEAWAY:  'class.campaignobject.sweepstake.giveaway',
      SWEEPSTAKEINSTANT:   'class.campaignobject.sweepstake.instant',
      SWEEPSTAKESKILL:     'class.campaignobject.sweepstake.skill',
      SWEEPSTAKEUGC:       'class.campaignobject.sweepstake.ugc',
      SWEEPSTAKEINNETWORK: 'class.campaignobject.sweepstake.ugc.innetwork',
      TOPN:                'class.campaignobject.topn',
      CONTESTPHOTO:        'class.campaignobject.ugc.contest.photo',
    },
    CAMPAIGNPROMOTION: {
      COUPON:  'class.campaignpromotion.coupon',
      DEFAULT: 'class.campaignpromotion.default',
      PRIZE:   'class.campaignpromotion.prize',
    },
    DISPLAYCONTAINER: {
      DEFAULT:   'class.displaycontainer.default',
      FACEBOOK:  'class.displaycontainer.facebook',
      INSTAGRAM: 'class.displaycontainer.instagram',
      SNAPCHAT:  'class.displaycontainer.snapchat',
      TWITTER:   'class.displaycontainer.twitter',
      WEB:       'class.displaycontainer.web',
    },
    DISPLAYOBJECT: {
      ADVOCACY:              'class.displayobject.advocacy',
      CALLOUT:               'class.displayobject.callout',
      CONFIRMATION:          'class.displayobject.confirmation',
      CONTENT:               'class.displayobject.content',
      COUNTDOWN:             'class.displayobject.countdown',
      CURTAIN:               'class.displayobject.curtain',
      CUSTOM:                'class.displayobject.custom',
      CUSTOMPAGE1:           'class.displayobject.custompage1',
      CUSTOMPAGE2:           'class.displayobject.custompage2',
      CUSTOMPAGE3:           'class.displayobject.custompage3',
      CUSTOMPAGE4:           'class.displayobject.custompage4',
      CUSTOMPAGE5:           'class.displayobject.custompage5',
      DASHBOARD:             'class.displayobject.dashboard',
      DEFAULT:               'class.displayobject.default',
      DETAIL:                'class.displayobject.detail',
      DETAILS:               'class.displayobject.details',
      ENTRIES:               'class.displayobject.entries',
      ENTRY:                 'class.displayobject.entry',
      FEED:                  'class.displayobject.feed',
      GALLERY:               'class.displayobject.gallery',
      GOAL:                  'class.displayobject.goal',
      IMAGE:                 'class.displayobject.image',
      IMAGEGALLERY:          'class.displayobject.imagegallery',
      INELIGIBLE:            'class.displayobject.ineligible',
      INSTRUCTIONS:          'class.displayobject.instructions',
      LANDING:               'class.displayobject.landing',
      LIVESTREAM:            'class.displayobject.livestream',
      OFFER:                 'class.displayobject.offer',
      PRIZES:                'class.displayobject.prizes',
      PROMOTION:             'class.displayobject.promotion',
      RESULTS:               'class.displayobject.results',
      REVEAL:                'class.displayobject.reveal',
      RULES:                 'class.displayobject.rules',
      SIGNUP:                'class.displayobject.signup',
      SOCIALCONTENTCAROUSEL: 'class.displayobject.socialcontentcarousel',
      SOCIALCONTENTMOSAIC:   'class.displayobject.socialcontentmosaic',
      SOCIALCONTENTWALL:     'class.displayobject.socialcontentwall',
      STREAM:                'class.displayobject.stream',
      TAB:                   'class.displayobject.tab',
      UNAPPROVED:            'class.displayobject.unapproved',
      VIDEO:                 'class.displayobject.video',
      VIDEOGALLERY:          'class.displayobject.videogallery',
      VOTING:                'class.displayobject.voting',
    },
    DISPLAYUNIT: {
      DEFAULT:  'class.displayunit.default',
      MULTIPLE: 'class.displayunit.multiple',
      SINGLE:   'class.displayunit.single',
      STREAM:   'class.displayunit.stream',
    },
    INTEGRATION: {
      ACCOUNT:  'class.integration.account',
      CAMPAIGN: 'class.integration.campaign',
      COMMON:   'class.integration.common',
      EMAIL:    'class.integration.email',
    },
    THEME: {
      BRAND:   'class.theme.brand',
      OTHER:   'class.theme.other',
      SPONSOR: 'class.theme.sponsor',
      SYSTEM:  'class.theme.system',
      TOPICAL: 'class.theme.topical',
    },
  },
  CONTENT: {
    STREAM: {
      BLOGPOST: 'content.stream.blogpost',
      CHECKIN:  'content.stream.checkin',
      GENERAL:  'content.stream.general',
      MEDIA:    'content.stream.media',
      POST:     'content.stream.post',
      REVIEW:   'content.stream.review',
      STATUS:   'content.stream.status',
    },
  },
  COUNTRY: {
    AD: 'country.AD',
    AE: 'country.AE',
    AF: 'country.AF',
    AG: 'country.AG',
    AI: 'country.AI',
    AL: 'country.AL',
    AM: 'country.AM',
    AO: 'country.AO',
    AR: 'country.AR',
    AS: 'country.AS',
    AT: 'country.AT',
    AU: 'country.AU',
    AW: 'country.AW',
    AX: 'country.AX',
    AZ: 'country.AZ',
    BA: 'country.BA',
    BB: 'country.BB',
    BD: 'country.BD',
    BE: 'country.BE',
    BF: 'country.BF',
    BG: 'country.BG',
    BH: 'country.BH',
    BI: 'country.BI',
    BJ: 'country.BJ',
    BL: 'country.BL',
    BM: 'country.BM',
    BN: 'country.BN',
    BO: 'country.BO',
    BQ: 'country.BQ',
    BR: 'country.BR',
    BS: 'country.BS',
    BT: 'country.BT',
    BV: 'country.BV',
    BW: 'country.BW',
    BY: 'country.BY',
    BZ: 'country.BZ',
    CA: 'country.CA',
    CC: 'country.CC',
    CD: 'country.CD',
    CF: 'country.CF',
    CG: 'country.CG',
    CH: 'country.CH',
    CI: 'country.CI',
    CK: 'country.CK',
    CL: 'country.CL',
    CM: 'country.CM',
    CN: 'country.CN',
    CO: 'country.CO',
    CR: 'country.CR',
    CU: 'country.CU',
    CV: 'country.CV',
    CW: 'country.CW',
    CX: 'country.CX',
    CY: 'country.CY',
    CZ: 'country.CZ',
    DE: 'country.DE',
    DJ: 'country.DJ',
    DK: 'country.DK',
    DM: 'country.DM',
    DO: 'country.DO',
    DZ: 'country.DZ',
    EC: 'country.EC',
    EE: 'country.EE',
    EG: 'country.EG',
    EH: 'country.EH',
    ER: 'country.ER',
    ES: 'country.ES',
    ET: 'country.ET',
    FI: 'country.FI',
    FJ: 'country.FJ',
    FK: 'country.FK',
    FM: 'country.FM',
    FO: 'country.FO',
    FR: 'country.FR',
    GA: 'country.GA',
    GB: 'country.GB',
    GD: 'country.GD',
    GE: 'country.GE',
    GF: 'country.GF',
    GG: 'country.GG',
    GH: 'country.GH',
    GI: 'country.GI',
    GL: 'country.GL',
    GM: 'country.GM',
    GN: 'country.GN',
    GP: 'country.GP',
    GQ: 'country.GQ',
    GR: 'country.GR',
    GS: 'country.GS',
    GT: 'country.GT',
    GU: 'country.GU',
    GW: 'country.GW',
    GY: 'country.GY',
    HK: 'country.HK',
    HN: 'country.HN',
    HR: 'country.HR',
    HT: 'country.HT',
    HU: 'country.HU',
    ID: 'country.ID',
    IE: 'country.IE',
    IL: 'country.IL',
    IM: 'country.IM',
    IN: 'country.IN',
    IO: 'country.IO',
    IQ: 'country.IQ',
    IR: 'country.IR',
    IS: 'country.IS',
    IT: 'country.IT',
    JE: 'country.JE',
    JM: 'country.JM',
    JO: 'country.JO',
    JP: 'country.JP',
    KE: 'country.KE',
    KG: 'country.KG',
    KH: 'country.KH',
    KI: 'country.KI',
    KM: 'country.KM',
    KN: 'country.KN',
    KP: 'country.KP',
    KR: 'country.KR',
    KW: 'country.KW',
    KY: 'country.KY',
    KZ: 'country.KZ',
    LA: 'country.LA',
    LB: 'country.LB',
    LC: 'country.LC',
    LI: 'country.LI',
    LK: 'country.LK',
    LR: 'country.LR',
    LS: 'country.LS',
    LT: 'country.LT',
    LU: 'country.LU',
    LV: 'country.LV',
    LY: 'country.LY',
    MA: 'country.MA',
    MC: 'country.MC',
    MD: 'country.MD',
    ME: 'country.ME',
    MF: 'country.MF',
    MG: 'country.MG',
    MH: 'country.MH',
    MK: 'country.MK',
    ML: 'country.ML',
    MM: 'country.MM',
    MN: 'country.MN',
    MO: 'country.MO',
    MP: 'country.MP',
    MQ: 'country.MQ',
    MR: 'country.MR',
    MS: 'country.MS',
    MT: 'country.MT',
    MU: 'country.MU',
    MV: 'country.MV',
    MW: 'country.MW',
    MX: 'country.MX',
    MY: 'country.MY',
    MZ: 'country.MZ',
    NA: 'country.NA',
    NC: 'country.NC',
    NE: 'country.NE',
    NF: 'country.NF',
    NG: 'country.NG',
    NI: 'country.NI',
    NL: 'country.NL',
    NO: 'country.NO',
    NP: 'country.NP',
    NR: 'country.NR',
    NU: 'country.NU',
    NZ: 'country.NZ',
    OM: 'country.OM',
    PA: 'country.PA',
    PE: 'country.PE',
    PF: 'country.PF',
    PG: 'country.PG',
    PH: 'country.PH',
    PK: 'country.PK',
    PL: 'country.PL',
    PM: 'country.PM',
    PN: 'country.PN',
    PR: 'country.PR',
    PS: 'country.PS',
    PT: 'country.PT',
    PW: 'country.PW',
    PY: 'country.PY',
    QA: 'country.QA',
    RE: 'country.RE',
    RO: 'country.RO',
    RS: 'country.RS',
    RU: 'country.RU',
    RW: 'country.RW',
    SA: 'country.SA',
    SB: 'country.SB',
    SC: 'country.SC',
    SD: 'country.SD',
    SE: 'country.SE',
    SG: 'country.SG',
    SH: 'country.SH',
    SI: 'country.SI',
    SJ: 'country.SJ',
    SK: 'country.SK',
    SL: 'country.SL',
    SM: 'country.SM',
    SN: 'country.SN',
    SO: 'country.SO',
    SR: 'country.SR',
    SS: 'country.SS',
    ST: 'country.ST',
    SV: 'country.SV',
    SX: 'country.SX',
    SY: 'country.SY',
    SZ: 'country.SZ',
    TC: 'country.TC',
    TD: 'country.TD',
    TG: 'country.TG',
    TH: 'country.TH',
    TJ: 'country.TJ',
    TK: 'country.TK',
    TL: 'country.TL',
    TM: 'country.TM',
    TN: 'country.TN',
    TO: 'country.TO',
    TR: 'country.TR',
    TT: 'country.TT',
    TV: 'country.TV',
    TW: 'country.TW',
    TZ: 'country.TZ',
    UA: 'country.UA',
    UG: 'country.UG',
    US: 'country.US',
    UY: 'country.UY',
    UZ: 'country.UZ',
    VA: 'country.VA',
    VC: 'country.VC',
    VE: 'country.VE',
    VG: 'country.VG',
    VI: 'country.VI',
    VN: 'country.VN',
    VU: 'country.VU',
    WF: 'country.WF',
    WS: 'country.WS',
    YE: 'country.YE',
    YT: 'country.YT',
    ZA: 'country.ZA',
    ZM: 'country.ZM',
    ZW: 'country.ZW',
  },
  DISPLAY: {
    CAMPAIGNPROMOTION: {
      COMPACT:  'display.campaignpromotion.compact',
      FEATURE:  'display.campaignpromotion.feature',
      HERO:     'display.campaignpromotion.hero',
      STANDARD: 'display.campaignpromotion.standard',
    },
    DISPLAY: {
      MULTIPAGE:        'display.multipage',
      PAGE:             'display.page',
      SLIDE:            'display.slide',
      SLIDE_HORIZONTAL: 'display.slide.horizontal',
      SLIDE_VERTICAL:   'display.slide.vertical',
    },
    SOCIALAUTH: {
      FORM: 'display.socialauth.form',
      GATE: 'display.socialauth.gate',
    },
    STRATEGY: {
      LARGE:    'display.strategy.large',
      MEDIUM:   'display.strategy.medium',
      STANDARD: 'display.strategy.standard',
    },
    STREAM: {
      COMMENTARY: 'display.stream.commentary',
      FEATURE:    'display.stream.feature',
      SHOW:       'display.stream.show',
      SPOTLIGHT:  'display.stream.spotlight',
    },
  },
  DISPLAYSCALE: {
    FASTLY: 'displayscale.fastly',
    NONE:   'displayscale.none',
    PAGE:   'displayscale.page',
    SPA:    'displayscale.spa',
  },
  EVENT: {
    INTEGRATION: {
      ENTRY:           'event.integration.entry',
      ENTRYGRANT:      'event.integration.entrygrant',
      INVALIDATEENTRY: 'event.integration.invalidateentry',
      NONE:            'event.integration.none',
      ONLOAD:          'event.integration.onload',
      PREENTRY:        'event.integration.preentry',
      PUBLISHCONTENT:  'event.integration.publishcontent',
      PUBLISHENTRY:    'event.integration.publishentry',
      VERIFY:          'event.integration.verify',
    },
  },
  EXCEPTION: {
    INTEGRATION: {
      CAMPAIGNMONITOR_API_AUTH_ERROR: 'exception.integration.campaignmonitor.api.auth.error',
      EMMA_API_AUTH_ERROR:            'exception.integration.emma.api.auth.error',
    },
  },
  EXTERNAL: {
    SERVICE: {
      BAZAARVOICE: 'external.service.bazaarvoice',
      BLOG:        'external.service.blog',
      FACEBOOK:    'external.service.facebook',
      FLICKR:      'external.service.flickr',
      INSTAGRAM:   'external.service.instagram',
      LINKEDIN:    'external.service.linkedin',
      LITHIUM:     'external.service.lithium',
      NEWSCRED:    'external.service.newscred',
      NOKIAAPPS:   'external.service.nokiaApps',
      NOKIAMUSIC:  'external.service.nokiaMusic',
      PINTEREST:   'external.service.pinterest',
      TWITTER:     'external.service.twitter',
      UGC:         'external.service.ugc',
      VIMEO:       'external.service.vimeo',
      VINE:        'external.service.vine',
      VK:          'external.service.vk',
      YOUTUBE:     'external.service.youtube',
    },
  },
  FORM: {
    VALIDFOR: {
      ANY:                               'form.validfor.any',
      CONTEST:                           'form.validfor.contest',
      CONTEST_CAPTION:                   'form.validfor.contest.caption',
      CONTEST_PHOTO:                     'form.validfor.contest.photo',
      CONTEST_VIDEO:                     'form.validfor.contest.video',
      COUPON:                            'form.validfor.coupon',
      COUPON_CODE:                       'form.validfor.coupon.code',
      COUPON_EXTCODES:                   'form.validfor.coupon.extcodes',
      COUPON_LINK:                       'form.validfor.coupon.link',
      COUPON_PRINT:                      'form.validfor.coupon.print',
      CUSTOM:                            'form.validfor.custom',
      QUIZ:                              'form.validfor.quiz',
      QUIZ_CATEGORY:                     'form.validfor.quiz.category',
      QUIZ_INTERVAL:                     'form.validfor.quiz.interval',
      QUIZ_QUICKFIRE:                    'form.validfor.quiz.quickfire',
      QUIZ_SCORE:                        'form.validfor.quiz.score',
      REVEAL:                            'form.validfor.reveal',
      REVEAL_ADVENTCALENDAR:             'form.validfor.reveal.adventcalendar',
      REVEAL_COUNTDOWN:                  'form.validfor.reveal.countdown',
      SIGNUP:                            'form.validfor.signup',
      SIGNUP_EVENT:                      'form.validfor.signup.event',
      SIGNUP_FEEDBACK:                   'form.validfor.signup.feedback',
      SIGNUP_NEWSLETTER:                 'form.validfor.signup.newsletter',
      SIGNUP_PRODUCT:                    'form.validfor.signup.product',
      SIGNUP_REGISTRATION:               'form.validfor.signup.registration',
      SWEEPSTAKE:                        'form.validfor.sweepstake',
      SWEEPSTAKE_CAPTION:                'form.validfor.sweepstake.caption',
      SWEEPSTAKE_GIVEAWAY:               'form.validfor.sweepstake.giveaway',
      SWEEPSTAKE_INSTANTWIN:             'form.validfor.sweepstake.instantwin',
      SWEEPSTAKE_MULTINETWORK_ENTRYFORM: 'form.validfor.sweepstake.multinetwork.entryform',
      SWEEPSTAKE_PHOTO:                  'form.validfor.sweepstake.photo',
      SWEEPSTAKE_SKILL:                  'form.validfor.sweepstake.skill',
    },
  },
  FORMAT: {
    DISPLAY:           { ALL: 'format.all', MACRO: 'format.macro', MICRO: 'format.micro' },
    CAMPAIGNPROMOTION: {
      CONTENT: 'format.campaignpromotion.content',
      IMAGE:   'format.campaignpromotion.image',
    },
  },
  FREQUENCY: {
    GRANTS: {
      DAILY:    'frequency.grants.daily',
      HOURLY:   'frequency.grants.hourly',
      LIFETIME: 'frequency.grants.lifetime',
      WEEKLY:   'frequency.grants.weekly',
    },
    METRIC: {
      DAILY:     'frequency.metric.daily',
      LIFETIME:  'frequency.metric.lifetime',
      MILESTONE: 'frequency.metric.milestone',
      WEEKLY:    'frequency.metric.weekly',
    },
    VOTING: {
      DAILY:  'frequency.voting.daily',
      ONCE:   'frequency.voting.once',
      WEEKLY: 'frequency.voting.weekly',
    },
  },
  INACTIVEFEED: {
    REASON: {
      NOCONTENTINGESTED:   'inactivefeed.reason.nocontentingested',
      WRONGAUTHENTICATION: 'inactivefeed.reason.wrongauthentication',
      WRONGCONFIG:         'inactivefeed.reason.wrongconfig',
    },
  },
  INTERACTION: {
    PARTITION: 'interaction.partition',
    STANDARD:  'interaction.standard',
  },
  LOCALE: {
    AR_AE: 'locale.ar_AE',
    AR_BH: 'locale.ar_BH',
    AR_DZ: 'locale.ar_DZ',
    AR_EG: 'locale.ar_EG',
    AR_IQ: 'locale.ar_IQ',
    AR_JO: 'locale.ar_JO',
    AR_KW: 'locale.ar_KW',
    AR_LB: 'locale.ar_LB',
    AR_LY: 'locale.ar_LY',
    AR_MA: 'locale.ar_MA',
    AR_OM: 'locale.ar_OM',
    AR_QA: 'locale.ar_QA',
    AR_SA: 'locale.ar_SA',
    AR_SD: 'locale.ar_SD',
    AR_SY: 'locale.ar_SY',
    AR_TN: 'locale.ar_TN',
    AR_YE: 'locale.ar_YE',
    AZ_AZ: 'locale.az_AZ',
    BE_BY: 'locale.be_BY',
    BG_BG: 'locale.bg_BG',
    CA_ES: 'locale.ca_ES',
    CS_CZ: 'locale.cs_CZ',
    DA_DK: 'locale.da_DK',
    DE_AT: 'locale.de_AT',
    DE_CH: 'locale.de_CH',
    DE_DE: 'locale.de_DE',
    DE_LU: 'locale.de_LU',
    EL_CY: 'locale.el_CY',
    EL_GR: 'locale.el_GR',
    EN_AU: 'locale.en_AU',
    EN_CA: 'locale.en_CA',
    EN_GB: 'locale.en_GB',
    EN_IE: 'locale.en_IE',
    EN_IN: 'locale.en_IN',
    EN_MT: 'locale.en_MT',
    EN_NZ: 'locale.en_NZ',
    EN_PH: 'locale.en_PH',
    EN_SG: 'locale.en_SG',
    EN_US: 'locale.en_US',
    EN_ZA: 'locale.en_ZA',
    ES_AR: 'locale.es_AR',
    ES_BO: 'locale.es_BO',
    ES_CL: 'locale.es_CL',
    ES_CO: 'locale.es_CO',
    ES_CR: 'locale.es_CR',
    ES_DO: 'locale.es_DO',
    ES_EC: 'locale.es_EC',
    ES_ES: 'locale.es_ES',
    ES_GT: 'locale.es_GT',
    ES_HN: 'locale.es_HN',
    ES_MX: 'locale.es_MX',
    ES_NI: 'locale.es_NI',
    ES_PA: 'locale.es_PA',
    ES_PE: 'locale.es_PE',
    ES_PR: 'locale.es_PR',
    ES_PY: 'locale.es_PY',
    ES_SV: 'locale.es_SV',
    ES_US: 'locale.es_US',
    ES_UY: 'locale.es_UY',
    ES_VE: 'locale.es_VE',
    ET_EE: 'locale.et_EE',
    FI_FI: 'locale.fi_FI',
    FR_BE: 'locale.fr_BE',
    FR_CA: 'locale.fr_CA',
    FR_CH: 'locale.fr_CH',
    FR_FR: 'locale.fr_FR',
    FR_LU: 'locale.fr_LU',
    GA_IE: 'locale.ga_IE',
    HE_IL: 'locale.he_IL',
    HI_IN: 'locale.hi_IN',
    HR_HR: 'locale.hr_HR',
    HU_HU: 'locale.hu_HU',
    IN_ID: 'locale.in_ID',
    IS_IS: 'locale.is_IS',
    IT_CH: 'locale.it_CH',
    IT_IT: 'locale.it_IT',
    JA_JP: 'locale.ja_JP',
    KK_KZ: 'locale.kk_KZ',
    KO_KR: 'locale.ko_KR',
    LT_LT: 'locale.lt_LT',
    LV_LV: 'locale.lv_LV',
    MK_MK: 'locale.mk_MK',
    MS_MY: 'locale.ms_MY',
    MT_MT: 'locale.mt_MT',
    MY_MM: 'locale.my_MM',
    NL_BE: 'locale.nl_BE',
    NL_NL: 'locale.nl_NL',
    NO_NO: 'locale.no_NO',
    PL_PL: 'locale.pl_PL',
    PT_BR: 'locale.pt_BR',
    PT_PT: 'locale.pt_PT',
    RO_RO: 'locale.ro_RO',
    RU_RU: 'locale.ru_RU',
    SK_SK: 'locale.sk_SK',
    SL_SI: 'locale.sl_SI',
    SR_BA: 'locale.sr_BA',
    SR_ME: 'locale.sr_ME',
    SR_RS: 'locale.sr_RS',
    SV_SE: 'locale.sv_SE',
    TH_TH: 'locale.th_TH',
    TR_TR: 'locale.tr_TR',
    UK_UA: 'locale.uk_UA',
    VI_VN: 'locale.vi_VN',
    ZH_CN: 'locale.zh_CN',
    ZH_HK: 'locale.zh_HK',
    ZH_SG: 'locale.zh_SG',
    ZH_TW: 'locale.zh_TW',
  },
  MODE: {
    PUBLISH: { PRODUCTION: 'mode.publish.live', STAGE: 'mode.publish.stage' },
  },
  PLAN: {
    ACCOUNT_SUBSCRIPTION: {
      ENTERPRISE_500: 'plan.account.subscription.enterprise.500',
      EXPRESS_100:    'plan.account.subscription.express.100',
    },
    ACCOUNT: { SYSTEM: 'plan.account.system' },
  },
  REFERENCE: { TARGETVALUE: 'reference.targetValue' },
  RENDER:    { CAMPAIGN: { LP: 'render.lp', OVERLAY: 'render.overlay' } },
  ROLE:      {
    ADDITIONAL: {
      DATAEXPORTER:        'role.additional.dataexporter',
      DATAVIEWER:          'role.additional.dataviewer',
      EXPERIENCEVIEWER:    'role.additional.experienceviewer',
      FORMEDITOR:          'role.additional.formeditor',
      INTEGRATIONSMANAGER: 'role.additional.integrationsmanager',
      LIBRARYMANAGER:      'role.additional.librarymanager',
      UGCMODERATOR:        'role.additional.ugcmoderator',
      WINNERMANAGER:       'role.additional.winnermanager',
    },
    MAIN: {
      ADMIN:     'role.main.admin',
      CREATOR:   'role.main.creator',
      INSIGHTS:  'role.main.insights',
      PUBLISHER: 'role.main.publisher',
      ROOT:      'role.main.root',
      SUPPORT:   'role.main.support',
    },
  },
  SCALE: {
    FAST:     'scale.fast',
    LEGACY:   'scale.legacy',
    STANDARD: 'scale.standard',
  },
  SCOPE:  { ACCOUNT: 'scope.account', CAMPAIGN: 'scope.campaign' },
  SOURCE: {
    INJECTED: 'source.injected',
    SEEDED:   'source.seeded',
    SOCIAL:   'source.social',
    UGC:      'source.ugc',
  },
  STATUS: {
    APPLICATION: {
      ACTIVE:  'status.application.active',
      INVALID: 'status.application.invalid',
    },
    APPROVAL: {
      APPROVED:    'status.approval.approved',
      NOTAPPROVED: 'status.approval.notapproved',
      REJECTED:    'status.approval.rejected',
    },
    ASSET: {
      ACTIVE:   'status.asset.active',
      INACTIVE: 'status.asset.inactive',
    },
    CAMPAIGNOBJECT: {
      DRAFT:     'status.campaignobject.draft',
      EXPIRED:   'status.campaignobject.expired',
      FAILED:    'status.campaignobject.failed',
      PUBLISHED: 'status.campaignobject.published',
      READY:     'status.campaignobject.ready',
      SCHEDULED: 'status.campaignobject.scheduled',
      TEMPLATE:  'status.campaignobject.template',
    },
    CAMPAIGNPROMOTION: {
      DRAFT:     'status.campaignpromotion.draft',
      EXPIRED:   'status.campaignpromotion.expired',
      NOTREADY:  'status.campaignpromotion.notready',
      PUBLISHED: 'status.campaignpromotion.published',
    },
    CHANNEL: {
      ACTIVE:   'status.channel.active',
      DEMO:     'status.channel.demo',
      INACTIVE: 'status.channel.inactive',
      INVALID:  'status.channel.invalid',
    },
    CONTENT: {
      ARCHIVED:        'status.content.archived',
      FAILED:          'status.content.failed',
      LAUNCHED:        'status.content.launched',
      MODERATE:        'status.content.moderate',
      PARTIALFAILED:   'status.content.partialfailed',
      PENDING:         'status.content.pending',
      PUBLISHED:       'status.content.published',
      READY:           'status.content.ready',
      REJECTED:        'status.content.rejected',
      REVIEW:          'status.content.review',
      RIGHTSREQUESTED: 'status.content.rightsrequested',
      RIGHTSREQUIRED:  'status.content.rightsrequired',
    },
    DISPLAYCONTAINER: {
      DRAFT:     'status.displaycontainer.draft',
      EXPIRED:   'status.displaycontainer.expired',
      PUBLISHED: 'status.displaycontainer.published',
      READY:     'status.displaycontainer.ready',
      SCHEDULED: 'status.displaycontainer.scheduled',
    },
    DISPLAYOBJECT: {
      DRAFT:     'status.displayobject.draft',
      EXPIRED:   'status.displayobject.expired',
      NOTREADY:  'status.displayobject.notready',
      PUBLISHED: 'status.displayobject.published',
    },
    DISPLAYUNIT: {
      ACTIVE:   'status.displayunit.active',
      INACTIVE: 'status.displayunit.inactive',
    },
    DOMAIN: {
      ACTIVE:   'status.domain.active',
      INACTIVE: 'status.domain.inactive',
    },
    DRAW: {
      CLOSED: 'status.draw.closed',
      DRAFT:  'status.draw.draft',
      DRAWN:  'status.draw.drawn',
      MANUAL: 'status.draw.manual',
    },
    ENTRY: {
      INVALIDBLACKLISTED:   'status.entry.invalidblacklisted',
      INVALIDMAXDAILY:      'status.entry.invaliddaily',
      VALID:                'status.entry.valid',
      INVALIDMAXENTRANTS:   'status.entry.invalidmaxentrants',
      INVALIDNOTAUTHORIZED: 'status.entry.invalidnotauthorized',
      INVALIDNOTELEGIBLE:   'status.entry.invalidnotelegible',
      INVALIDONCE:          'status.entry.invalidonce',
      INVALIDOUTOFTIME:     'status.entry.invalidoutoftime',
      PENDING:              'status.entry.unviewed',
      REVIEWED:             'status.entry.viewed',
    },
    ENTRY_VALID: {
      INVALIDBLACKLISTED:   'status.entry.valid.invalidblacklisted',
      INVALIDMAXDAILY:      'status.entry.valid.invaliddaily',
      VALID:                'status.entry.valid.valid',
      INVALIDMAXENTRANTS:   'status.entry.valid.invalidmaxentrants',
      INVALIDNOTAUTHORIZED: 'status.entry.valid.invalidnotauthorized',
      INVALIDNOTELEGIBLE:   'status.entry.valid.invalidnotelegible',
      INVALIDONCE:          'status.entry.valid.invalidonce',
      INVALIDOUTOFTIME:     'status.entry.valid.invalidoutoftime',
    },
    ENTRY_WINNER: {
      EIGHTHPLACE:  'status.entry.winner.eighthplace',
      ENTRY:        'status.entry.winner.entry',
      FIFTHPLACE:   'status.entry.winner.fifthplace',
      FINALIST:     'status.entry.winner.finalist',
      FIRSTPLACE:   'status.entry.winner.firstplace',
      FOURTHPLACE:  'status.entry.winner.fourthplace',
      NINTHPLACE:   'status.entry.winner.ninthplace',
      RUNNERUP:     'status.entry.winner.runnerup',
      SECONDPLACE:  'status.entry.winner.secondplace',
      SEVENTHPLACE: 'status.entry.winner.seventhplace',
      SIXTHPLACE:   'status.entry.winner.sixthplace',
      TENTHPLACE:   'status.entry.winner.tenthplace',
      THIRDPLACE:   'status.entry.winner.thirdplace',
      VALID:        'status.entry.winner.winner',
    },
    EXPORT: {
      EMPTY:      'status.export.empty',
      FAILED:     'status.export.failed',
      FINISHED:   'status.export.finished',
      INPROGRESS: 'status.export.inprogress',
      SCHEDULED:  'status.export.scheduled',
    },
    INTEGRATION: {
      ACTIVE:   'status.integration.active',
      INACTIVE: 'status.integration.inactive',
    },
    INTEGRATIONTEMPLATE: {
      ACTIVE:   'status.integrationtemplate.active',
      INACTIVE: 'status.integrationtemplate.inactive',
      USED:     'status.integrationtemplate.used',
    },
    PUBLISH: {
      ERROR:   'status.publish.error',
      WARNING: 'status.publish.warning',
    },
    SYSTEMSTATUS: {
      FAILED:     'status.systemstatus.failed',
      PENDING:    'status.systemstatus.pending',
      PROCESSING: 'status.systemstatus.processing',
      READY:      'status.systemstatus.ready',
      RETRY:      'status.systemstatus.retry',
      UPLOADING:  'status.systemstatus.uploading',
    },
    THEME: {
      ACTIVE:   'status.theme.active',
      INACTIVE: 'status.theme.inactive',
    },
  },
  STRATEGY: {
    ALLOCATION_LEAD: {
      ENTER:     'strategy.allocation.lead.enter',
      REFERRALS: 'strategy.allocation.lead.referrals',
      SCORE:     'strategy.allocation.lead.score',
      SHARES:    'strategy.allocation.lead.shares',
    },
    ANNOUNCEMENT: {
      DAILY:  'strategy.announcement.daily',
      DATE:   'strategy.announcement.date',
      WEEKLY: 'strategy.announcement.weekly',
    },
    CAMPAIGNENTRY: {
      ANONYMOUS: 'strategy.campaignentry.anonymous',
      FORM:      'strategy.campaignentry.form',
      INNETWORK: 'strategy.campaignentry.innetwork',
      NONE:      'strategy.campaignentry.none',
    },
    CUSTOMORDER: {
      BOTTOM: 'strategy.customorder.bottom',
      TOP:    'strategy.customorder.top',
    },
    DELIVERY_COUPON: {
      CONTENT:   'strategy.delivery.coupon.content',
      IMAGE:     'strategy.delivery.coupon.image',
      LINK:      'strategy.delivery.coupon.link',
      OFFERCODE: 'strategy.delivery.coupon.offerCode',
    },
    DELIVERY_PRIZE: { DISPLAY: 'strategy.delivery.prize.display' },
    DISTRIBUTION:   {
      ODDS:                   'strategy.distribution.odds',
      TIMEUNIFORM:            'strategy.distribution.timeuniform',
      TIMEUNIFORM_NOROLLOVER: 'strategy.distribution.timeuniform.norollover',
    },
    ELIGIBILITY_PROFILE: {
      BADGES: 'strategy.eligibility.profile.badges',
      LEVEL:  'strategy.eligibility.profile.level',
      POINTS: 'strategy.eligibility.profile.points',
    },
    ENTRY: {
      DAILY:  'strategy.entry.daily',
      HOURLY: 'strategy.entry.hourly',
      NONE:   'strategy.entry.none',
      ONCE:   'strategy.entry.once',
      CUSTOM: 'strategy.entry.custom',
    },
    FRAUD: {
      DYNAMICCAPTCHATURNSTILE: 'strategy.fraud.dynamiccaptchaturnstile',
      NONE:                    'strategy.fraud.none',
      TURNSTILE:               'strategy.fraud.turnstile',
    },
    JUDGING: {
      JURY:           'strategy.judging.jury',
      JURYTHENPUBLIC: 'strategy.judging.jurythenpublic',
      PUBLIC:         'strategy.judging.public',
      PUBLICTHENJURY: 'strategy.judging.publicthenjury',
    },
    LOCATION: {
      LASTFIELD: 'strategy.location.lastfield',
      LASTSLIDE: 'strategy.location.lastslide',
    },
    PRIVACYMGMT: {
      CUSTOM:         'strategy.privacymgmt.custom',
      CUSTOM3RDPARTY: 'strategy.privacymgmt.custom3rdparty',
      DEFAULT:        'strategy.privacymgmt.experiences',
      NONE:           'strategy.privacymgmt.none',
    },
    PROMOTION_DETAILS: {
      CLICKTHROUGH: 'strategy.promotiondetails.clickthrough',
      INLINE:       'strategy.promotiondetails.pagebuilder.inline',
      NONE:         'strategy.promotiondetails.none',
      OVERLAY:      'strategy.promotiondetails.overlay',
      PAGEBUILDER:  'strategy.promotiondetails.pagebuilder',
    },
    PUBLISHSTREAM: {
      AUTO:   'strategy.publishstream.auto',
      REVIEW: 'strategy.publishstream.review',
    },
    SOCIALAUTH: {
      CUSTOMAUTHENTICATION: 'strategy.socialauth.customauthentication',
      DISABLED:             'strategy.socialauth.disabled',
      SOCIALSIGNIN:         'strategy.socialauth.socialsignin',
    },
    SOCIALAUTHCUSTOM: {
      DISABLED: 'strategy.socialauthcustom.disabled',
      ENABLED:  'strategy.socialauthcustom.enabled',
    },
    SOCIALAUTHENFORCEMENT: {
      OPTIONAL: 'strategy.socialauthenforcement.optional',
      REQUIRED: 'strategy.socialauthenforcement.required',
    },
    SOCIALAUTHSIGNIN: {
      DISABLED: 'strategy.socialauthsignin.disabled',
      ENABLED:  'strategy.socialauthsignin.enabled',
    },
    VOTING: {
      COUNTER:       'strategy.voting.counter',
      CTA:           'strategy.voting.cta',
      GLOBALCOUNTER: 'strategy.voting.globalcounter',
      NONE:          'strategy.voting.none',
      LIKE:          'strategy.voting.posttowall',
    },
  },
  TIMEZONE: {
    'AFRICA/ABIDJAN':                   'timezone.Africa/Abidjan',
    'AFRICA/ACCRA':                     'timezone.Africa/Accra',
    'AFRICA/ADDIS_ABABA':               'timezone.Africa/Addis_Ababa',
    'AFRICA/ALGIERS':                   'timezone.Africa/Algiers',
    'AFRICA/ASMARA':                    'timezone.Africa/Asmara',
    'AFRICA/ASMERA':                    'timezone.Africa/Asmera',
    'AFRICA/BAMAKO':                    'timezone.Africa/Bamako',
    'AFRICA/BANGUI':                    'timezone.Africa/Bangui',
    'AFRICA/BANJUL':                    'timezone.Africa/Banjul',
    'AFRICA/BISSAU':                    'timezone.Africa/Bissau',
    'AFRICA/BLANTYRE':                  'timezone.Africa/Blantyre',
    'AFRICA/BRAZZAVILLE':               'timezone.Africa/Brazzaville',
    'AFRICA/BUJUMBURA':                 'timezone.Africa/Bujumbura',
    'AFRICA/CAIRO':                     'timezone.Africa/Cairo',
    'AFRICA/CASABLANCA':                'timezone.Africa/Casablanca',
    'AFRICA/CEUTA':                     'timezone.Africa/Ceuta',
    'AFRICA/CONAKRY':                   'timezone.Africa/Conakry',
    'AFRICA/DAKAR':                     'timezone.Africa/Dakar',
    'AFRICA/DAR_ES_SALAAM':             'timezone.Africa/Dar_es_Salaam',
    'AFRICA/DJIBOUTI':                  'timezone.Africa/Djibouti',
    'AFRICA/DOUALA':                    'timezone.Africa/Douala',
    'AFRICA/EL_AAIUN':                  'timezone.Africa/El_Aaiun',
    'AFRICA/FREETOWN':                  'timezone.Africa/Freetown',
    'AFRICA/GABORONE':                  'timezone.Africa/Gaborone',
    'AFRICA/HARARE':                    'timezone.Africa/Harare',
    'AFRICA/JOHANNESBURG':              'timezone.Africa/Johannesburg',
    'AFRICA/JUBA':                      'timezone.Africa/Juba',
    'AFRICA/KAMPALA':                   'timezone.Africa/Kampala',
    'AFRICA/KHARTOUM':                  'timezone.Africa/Khartoum',
    'AFRICA/KIGALI':                    'timezone.Africa/Kigali',
    'AFRICA/KINSHASA':                  'timezone.Africa/Kinshasa',
    'AFRICA/LAGOS':                     'timezone.Africa/Lagos',
    'AFRICA/LIBREVILLE':                'timezone.Africa/Libreville',
    'AFRICA/LOME':                      'timezone.Africa/Lome',
    'AFRICA/LUANDA':                    'timezone.Africa/Luanda',
    'AFRICA/LUBUMBASHI':                'timezone.Africa/Lubumbashi',
    'AFRICA/LUSAKA':                    'timezone.Africa/Lusaka',
    'AFRICA/MALABO':                    'timezone.Africa/Malabo',
    'AFRICA/MAPUTO':                    'timezone.Africa/Maputo',
    'AFRICA/MASERU':                    'timezone.Africa/Maseru',
    'AFRICA/MBABANE':                   'timezone.Africa/Mbabane',
    'AFRICA/MOGADISHU':                 'timezone.Africa/Mogadishu',
    'AFRICA/MONROVIA':                  'timezone.Africa/Monrovia',
    'AFRICA/NAIROBI':                   'timezone.Africa/Nairobi',
    'AFRICA/NDJAMENA':                  'timezone.Africa/Ndjamena',
    'AFRICA/NIAMEY':                    'timezone.Africa/Niamey',
    'AFRICA/NOUAKCHOTT':                'timezone.Africa/Nouakchott',
    'AFRICA/OUAGADOUGOU':               'timezone.Africa/Ouagadougou',
    'AFRICA/PORTO-NOVO':                'timezone.Africa/Porto-Novo',
    'AFRICA/SAO_TOME':                  'timezone.Africa/Sao_Tome',
    'AFRICA/TIMBUKTU':                  'timezone.Africa/Timbuktu',
    'AFRICA/TRIPOLI':                   'timezone.Africa/Tripoli',
    'AFRICA/TUNIS':                     'timezone.Africa/Tunis',
    'AFRICA/WINDHOEK':                  'timezone.Africa/Windhoek',
    'AMERICA/ADAK':                     'timezone.America/Adak',
    'AMERICA/ANCHORAGE':                'timezone.America/Anchorage',
    'AMERICA/ANGUILLA':                 'timezone.America/Anguilla',
    'AMERICA/ANTIGUA':                  'timezone.America/Antigua',
    'AMERICA/ARGENTINA/BUENOS_AIRES':   'timezone.America/Argentina/Buenos_Aires',
    'AMERICA/ARGENTINA/CATAMARCA':      'timezone.America/Argentina/Catamarca',
    'AMERICA/ARGENTINA/COMODRIVADAVIA': 'timezone.America/Argentina/ComodRivadavia',
    'AMERICA/ARGENTINA/CORDOBA':        'timezone.America/Argentina/Cordoba',
    'AMERICA/ARGENTINA/JUJUY':          'timezone.America/Argentina/Jujuy',
    'AMERICA/ARGENTINA/LA_RIOJA':       'timezone.America/Argentina/La_Rioja',
    'AMERICA/ARGENTINA/MENDOZA':        'timezone.America/Argentina/Mendoza',
    'AMERICA/ARGENTINA/RIO_GALLEGOS':   'timezone.America/Argentina/Rio_Gallegos',
    'AMERICA/ARGENTINA/SALTA':          'timezone.America/Argentina/Salta',
    'AMERICA/ARGENTINA/SAN_JUAN':       'timezone.America/Argentina/San_Juan',
    'AMERICA/ARGENTINA/SAN_LUIS':       'timezone.America/Argentina/San_Luis',
    'AMERICA/ARGENTINA/TUCUMAN':        'timezone.America/Argentina/Tucuman',
    'AMERICA/ARGENTINA/USHUAIA':        'timezone.America/Argentina/Ushuaia',
    'AMERICA/ARUBA':                    'timezone.America/Aruba',
    'AMERICA/ASUNCION':                 'timezone.America/Asuncion',
    'AMERICA/ATIKOKAN':                 'timezone.America/Atikokan',
    'AMERICA/ATKA':                     'timezone.America/Atka',
    'AMERICA/BAHIA':                    'timezone.America/Bahia',
    'AMERICA/BAHIA_BANDERAS':           'timezone.America/Bahia_Banderas',
    'AMERICA/BARBADOS':                 'timezone.America/Barbados',
    'AMERICA/BELEM':                    'timezone.America/Belem',
    'AMERICA/BELIZE':                   'timezone.America/Belize',
    'AMERICA/BLANC-SABLON':             'timezone.America/Blanc-Sablon',
    'AMERICA/BOA_VISTA':                'timezone.America/Boa_Vista',
    'AMERICA/BOGOTA':                   'timezone.America/Bogota',
    'AMERICA/BOISE':                    'timezone.America/Boise',
    'AMERICA/BUENOS_AIRES':             'timezone.America/Buenos_Aires',
    'AMERICA/CAMBRIDGE_BAY':            'timezone.America/Cambridge_Bay',
    'AMERICA/CAMPO_GRANDE':             'timezone.America/Campo_Grande',
    'AMERICA/CANCUN':                   'timezone.America/Cancun',
    'AMERICA/CARACAS':                  'timezone.America/Caracas',
    'AMERICA/CATAMARCA':                'timezone.America/Catamarca',
    'AMERICA/CAYENNE':                  'timezone.America/Cayenne',
    'AMERICA/CAYMAN':                   'timezone.America/Cayman',
    'AMERICA/CHICAGO':                  'timezone.America/Chicago',
    'AMERICA/CHIHUAHUA':                'timezone.America/Chihuahua',
    'AMERICA/CORAL_HARBOUR':            'timezone.America/Coral_Harbour',
    'AMERICA/CORDOBA':                  'timezone.America/Cordoba',
    'AMERICA/COSTA_RICA':               'timezone.America/Costa_Rica',
    'AMERICA/CRESTON':                  'timezone.America/Creston',
    'AMERICA/CUIABA':                   'timezone.America/Cuiaba',
    'AMERICA/CURACAO':                  'timezone.America/Curacao',
    'AMERICA/DANMARKSHAVN':             'timezone.America/Danmarkshavn',
    'AMERICA/DAWSON':                   'timezone.America/Dawson',
    'AMERICA/DAWSON_CREEK':             'timezone.America/Dawson_Creek',
    'AMERICA/DENVER':                   'timezone.America/Denver',
    'AMERICA/DETROIT':                  'timezone.America/Detroit',
    'AMERICA/DOMINICA':                 'timezone.America/Dominica',
    'AMERICA/EDMONTON':                 'timezone.America/Edmonton',
    'AMERICA/EIRUNEPE':                 'timezone.America/Eirunepe',
    'AMERICA/EL_SALVADOR':              'timezone.America/El_Salvador',
    'AMERICA/ENSENADA':                 'timezone.America/Ensenada',
    'AMERICA/FORT_NELSON':              'timezone.America/Fort_Nelson',
    'AMERICA/FORT_WAYNE':               'timezone.America/Fort_Wayne',
    'AMERICA/FORTALEZA':                'timezone.America/Fortaleza',
    'AMERICA/GLACE_BAY':                'timezone.America/Glace_Bay',
    'AMERICA/GODTHAB':                  'timezone.America/Godthab',
    'AMERICA/GOOSE_BAY':                'timezone.America/Goose_Bay',
    'AMERICA/GRAND_TURK':               'timezone.America/Grand_Turk',
    'AMERICA/GRENADA':                  'timezone.America/Grenada',
    'AMERICA/GUADELOUPE':               'timezone.America/Guadeloupe',
    'AMERICA/GUATEMALA':                'timezone.America/Guatemala',
    'AMERICA/GUAYAQUIL':                'timezone.America/Guayaquil',
    'AMERICA/GUYANA':                   'timezone.America/Guyana',
    'AMERICA/HALIFAX':                  'timezone.America/Halifax',
    'AMERICA/HAVANA':                   'timezone.America/Havana',
    'AMERICA/HERMOSILLO':               'timezone.America/Hermosillo',
    'AMERICA/INDIANA/INDIANAPOLIS':     'timezone.America/Indiana/Indianapolis',
    'AMERICA/INDIANA/KNOX':             'timezone.America/Indiana/Knox',
    'AMERICA/INDIANA/MARENGO':          'timezone.America/Indiana/Marengo',
    'AMERICA/INDIANA/PETERSBURG':       'timezone.America/Indiana/Petersburg',
    'AMERICA/INDIANA/TELL_CITY':        'timezone.America/Indiana/Tell_City',
    'AMERICA/INDIANA/VEVAY':            'timezone.America/Indiana/Vevay',
    'AMERICA/INDIANA/VINCENNES':        'timezone.America/Indiana/Vincennes',
    'AMERICA/INDIANA/WINAMAC':          'timezone.America/Indiana/Winamac',
    'AMERICA/INDIANAPOLIS':             'timezone.America/Indianapolis',
    'AMERICA/INUVIK':                   'timezone.America/Inuvik',
    'AMERICA/IQALUIT':                  'timezone.America/Iqaluit',
    'AMERICA/JAMAICA':                  'timezone.America/Jamaica',
    'AMERICA/JUJUY':                    'timezone.America/Jujuy',
    'AMERICA/JUNEAU':                   'timezone.America/Juneau',
    'AMERICA/KENTUCKY/LOUISVILLE':      'timezone.America/Kentucky/Louisville',
    'AMERICA/KENTUCKY/MONTICELLO':      'timezone.America/Kentucky/Monticello',
    'AMERICA/KNOX_IN':                  'timezone.America/Knox_IN',
    'AMERICA/KRALENDIJK':               'timezone.America/Kralendijk',
    'AMERICA/LA_PAZ':                   'timezone.America/La_Paz',
    'AMERICA/LIMA':                     'timezone.America/Lima',
    'AMERICA/LOS_ANGELES':              'timezone.America/Los_Angeles',
    'AMERICA/LOUISVILLE':               'timezone.America/Louisville',
    'AMERICA/LOWER_PRINCES':            'timezone.America/Lower_Princes',
    'AMERICA/MACEIO':                   'timezone.America/Maceio',
    'AMERICA/MANAGUA':                  'timezone.America/Managua',
    'AMERICA/MANAUS':                   'timezone.America/Manaus',
    'AMERICA/MARIGOT':                  'timezone.America/Marigot',
    'AMERICA/MARTINIQUE':               'timezone.America/Martinique',
    'AMERICA/MATAMOROS':                'timezone.America/Matamoros',
    'AMERICA/MAZATLAN':                 'timezone.America/Mazatlan',
    'AMERICA/MENDOZA':                  'timezone.America/Mendoza',
    'AMERICA/MENOMINEE':                'timezone.America/Menominee',
    'AMERICA/MERIDA':                   'timezone.America/Merida',
    'AMERICA/METLAKATLA':               'timezone.America/Metlakatla',
    'AMERICA/MEXICO_CITY':              'timezone.America/Mexico_City',
    'AMERICA/MIQUELON':                 'timezone.America/Miquelon',
    'AMERICA/MONCTON':                  'timezone.America/Moncton',
    'AMERICA/MONTERREY':                'timezone.America/Monterrey',
    'AMERICA/MONTEVIDEO':               'timezone.America/Montevideo',
    'AMERICA/MONTREAL':                 'timezone.America/Montreal',
    'AMERICA/MONTSERRAT':               'timezone.America/Montserrat',
    'AMERICA/NASSAU':                   'timezone.America/Nassau',
    'AMERICA/NEW_YORK':                 'timezone.America/New_York',
    'AMERICA/NIPIGON':                  'timezone.America/Nipigon',
    'AMERICA/NOME':                     'timezone.America/Nome',
    'AMERICA/NORONHA':                  'timezone.America/Noronha',
    'AMERICA/NORTH_DAKOTA/BEULAH':      'timezone.America/North_Dakota/Beulah',
    'AMERICA/NORTH_DAKOTA/CENTER':      'timezone.America/North_Dakota/Center',
    'AMERICA/NORTH_DAKOTA/NEW_SALEM':   'timezone.America/North_Dakota/New_Salem',
    'AMERICA/NUUK':                     'timezone.America/Nuuk',
    'AMERICA/OJINAGA':                  'timezone.America/Ojinaga',
    'AMERICA/PANAMA':                   'timezone.America/Panama',
    'AMERICA/PANGNIRTUNG':              'timezone.America/Pangnirtung',
    'AMERICA/PARAMARIBO':               'timezone.America/Paramaribo',
    'AMERICA/PHOENIX':                  'timezone.America/Phoenix',
    'AMERICA/PORT-AU-PRINCE':           'timezone.America/Port-au-Prince',
    'AMERICA/PORT_OF_SPAIN':            'timezone.America/Port_of_Spain',
    'AMERICA/PORTO_ACRE':               'timezone.America/Porto_Acre',
    'AMERICA/PORTO_VELHO':              'timezone.America/Porto_Velho',
    'AMERICA/PUERTO_RICO':              'timezone.America/Puerto_Rico',
    'AMERICA/PUNTA_ARENAS':             'timezone.America/Punta_Arenas',
    'AMERICA/RAINY_RIVER':              'timezone.America/Rainy_River',
    'AMERICA/RANKIN_INLET':             'timezone.America/Rankin_Inlet',
    'AMERICA/RECIFE':                   'timezone.America/Recife',
    'AMERICA/REGINA':                   'timezone.America/Regina',
    'AMERICA/RESOLUTE':                 'timezone.America/Resolute',
    'AMERICA/RIO_BRANCO':               'timezone.America/Rio_Branco',
    'AMERICA/ROSARIO':                  'timezone.America/Rosario',
    'AMERICA/SANTA_ISABEL':             'timezone.America/Santa_Isabel',
    'AMERICA/SANTAREM':                 'timezone.America/Santarem',
    'AMERICA/SANTIAGO':                 'timezone.America/Santiago',
    'AMERICA/SANTO_DOMINGO':            'timezone.America/Santo_Domingo',
    'AMERICA/SAO_PAULO':                'timezone.America/Sao_Paulo',
    'AMERICA/SCORESBYSUND':             'timezone.America/Scoresbysund',
    'AMERICA/SHIPROCK':                 'timezone.America/Shiprock',
    'AMERICA/SITKA':                    'timezone.America/Sitka',
    'AMERICA/ST_BARTHELEMY':            'timezone.America/St_Barthelemy',
    'AMERICA/ST_JOHNS':                 'timezone.America/St_Johns',
    'AMERICA/ST_KITTS':                 'timezone.America/St_Kitts',
    'AMERICA/ST_LUCIA':                 'timezone.America/St_Lucia',
    'AMERICA/ST_THOMAS':                'timezone.America/St_Thomas',
    'AMERICA/ST_VINCENT':               'timezone.America/St_Vincent',
    'AMERICA/SWIFT_CURRENT':            'timezone.America/Swift_Current',
    'AMERICA/TEGUCIGALPA':              'timezone.America/Tegucigalpa',
    'AMERICA/THULE':                    'timezone.America/Thule',
    'AMERICA/THUNDER_BAY':              'timezone.America/Thunder_Bay',
    'AMERICA/TIJUANA':                  'timezone.America/Tijuana',
    'AMERICA/TORONTO':                  'timezone.America/Toronto',
    'AMERICA/TORTOLA':                  'timezone.America/Tortola',
    'AMERICA/VANCOUVER':                'timezone.America/Vancouver',
    'AMERICA/VIRGIN':                   'timezone.America/Virgin',
    'AMERICA/WHITEHORSE':               'timezone.America/Whitehorse',
    'AMERICA/WINNIPEG':                 'timezone.America/Winnipeg',
    'AMERICA/YAKUTAT':                  'timezone.America/Yakutat',
    'AMERICA/YELLOWKNIFE':              'timezone.America/Yellowknife',
    'ANTARCTICA/CASEY':                 'timezone.Antarctica/Casey',
    'ANTARCTICA/DAVIS':                 'timezone.Antarctica/Davis',
    'ANTARCTICA/DUMONTDURVILLE':        'timezone.Antarctica/DumontDUrville',
    'ANTARCTICA/MACQUARIE':             'timezone.Antarctica/Macquarie',
    'ANTARCTICA/MAWSON':                'timezone.Antarctica/Mawson',
    'ANTARCTICA/MCMURDO':               'timezone.Antarctica/McMurdo',
    'ANTARCTICA/PALMER':                'timezone.Antarctica/Palmer',
    'ANTARCTICA/ROTHERA':               'timezone.Antarctica/Rothera',
    'ANTARCTICA/SOUTH_POLE':            'timezone.Antarctica/South_Pole',
    'ANTARCTICA/SYOWA':                 'timezone.Antarctica/Syowa',
    'ANTARCTICA/TROLL':                 'timezone.Antarctica/Troll',
    'ANTARCTICA/VOSTOK':                'timezone.Antarctica/Vostok',
    'ASIA/ADEN':                        'timezone.Asia/Aden',
    'ASIA/ALMATY':                      'timezone.Asia/Almaty',
    'ASIA/AMMAN':                       'timezone.Asia/Amman',
    'ASIA/ANADYR':                      'timezone.Asia/Anadyr',
    'ASIA/AQTAU':                       'timezone.Asia/Aqtau',
    'ASIA/AQTOBE':                      'timezone.Asia/Aqtobe',
    'ASIA/ASHGABAT':                    'timezone.Asia/Ashgabat',
    'ASIA/ASHKHABAD':                   'timezone.Asia/Ashkhabad',
    'ASIA/ATYRAU':                      'timezone.Asia/Atyrau',
    'ASIA/BAGHDAD':                     'timezone.Asia/Baghdad',
    'ASIA/BAHRAIN':                     'timezone.Asia/Bahrain',
    'ASIA/BAKU':                        'timezone.Asia/Baku',
    'ASIA/BANGKOK':                     'timezone.Asia/Bangkok',
    'ASIA/BARNAUL':                     'timezone.Asia/Barnaul',
    'ASIA/BEIRUT':                      'timezone.Asia/Beirut',
    'ASIA/BISHKEK':                     'timezone.Asia/Bishkek',
    'ASIA/BRUNEI':                      'timezone.Asia/Brunei',
    'ASIA/CALCUTTA':                    'timezone.Asia/Calcutta',
    'ASIA/CHITA':                       'timezone.Asia/Chita',
    'ASIA/CHOIBALSAN':                  'timezone.Asia/Choibalsan',
    'ASIA/CHONGQING':                   'timezone.Asia/Chongqing',
    'ASIA/CHUNGKING':                   'timezone.Asia/Chungking',
    'ASIA/COLOMBO':                     'timezone.Asia/Colombo',
    'ASIA/DACCA':                       'timezone.Asia/Dacca',
    'ASIA/DAMASCUS':                    'timezone.Asia/Damascus',
    'ASIA/DHAKA':                       'timezone.Asia/Dhaka',
    'ASIA/DILI':                        'timezone.Asia/Dili',
    'ASIA/DUBAI':                       'timezone.Asia/Dubai',
    'ASIA/DUSHANBE':                    'timezone.Asia/Dushanbe',
    'ASIA/FAMAGUSTA':                   'timezone.Asia/Famagusta',
    'ASIA/GAZA':                        'timezone.Asia/Gaza',
    'ASIA/HARBIN':                      'timezone.Asia/Harbin',
    'ASIA/HEBRON':                      'timezone.Asia/Hebron',
    'ASIA/HO_CHI_MINH':                 'timezone.Asia/Ho_Chi_Minh',
    'ASIA/HONG_KONG':                   'timezone.Asia/Hong_Kong',
    'ASIA/HOVD':                        'timezone.Asia/Hovd',
    'ASIA/IRKUTSK':                     'timezone.Asia/Irkutsk',
    'ASIA/ISTANBUL':                    'timezone.Asia/Istanbul',
    'ASIA/JAKARTA':                     'timezone.Asia/Jakarta',
    'ASIA/JAYAPURA':                    'timezone.Asia/Jayapura',
    'ASIA/JERUSALEM':                   'timezone.Asia/Jerusalem',
    'ASIA/KABUL':                       'timezone.Asia/Kabul',
    'ASIA/KAMCHATKA':                   'timezone.Asia/Kamchatka',
    'ASIA/KARACHI':                     'timezone.Asia/Karachi',
    'ASIA/KASHGAR':                     'timezone.Asia/Kashgar',
    'ASIA/KATHMANDU':                   'timezone.Asia/Kathmandu',
    'ASIA/KATMANDU':                    'timezone.Asia/Katmandu',
    'ASIA/KHANDYGA':                    'timezone.Asia/Khandyga',
    'ASIA/KOLKATA':                     'timezone.Asia/Kolkata',
    'ASIA/KRASNOYARSK':                 'timezone.Asia/Krasnoyarsk',
    'ASIA/KUALA_LUMPUR':                'timezone.Asia/Kuala_Lumpur',
    'ASIA/KUCHING':                     'timezone.Asia/Kuching',
    'ASIA/KUWAIT':                      'timezone.Asia/Kuwait',
    'ASIA/MACAO':                       'timezone.Asia/Macao',
    'ASIA/MACAU':                       'timezone.Asia/Macau',
    'ASIA/MAGADAN':                     'timezone.Asia/Magadan',
    'ASIA/MAKASSAR':                    'timezone.Asia/Makassar',
    'ASIA/MANILA':                      'timezone.Asia/Manila',
    'ASIA/MUSCAT':                      'timezone.Asia/Muscat',
    'ASIA/NICOSIA':                     'timezone.Asia/Nicosia',
    'ASIA/NOVOKUZNETSK':                'timezone.Asia/Novokuznetsk',
    'ASIA/NOVOSIBIRSK':                 'timezone.Asia/Novosibirsk',
    'ASIA/OMSK':                        'timezone.Asia/Omsk',
    'ASIA/ORAL':                        'timezone.Asia/Oral',
    'ASIA/PHNOM_PENH':                  'timezone.Asia/Phnom_Penh',
    'ASIA/PONTIANAK':                   'timezone.Asia/Pontianak',
    'ASIA/PYONGYANG':                   'timezone.Asia/Pyongyang',
    'ASIA/QATAR':                       'timezone.Asia/Qatar',
    'ASIA/QOSTANAY':                    'timezone.Asia/Qostanay',
    'ASIA/QYZYLORDA':                   'timezone.Asia/Qyzylorda',
    'ASIA/RANGOON':                     'timezone.Asia/Rangoon',
    'ASIA/RIYADH':                      'timezone.Asia/Riyadh',
    'ASIA/SAIGON':                      'timezone.Asia/Saigon',
    'ASIA/SAKHALIN':                    'timezone.Asia/Sakhalin',
    'ASIA/SAMARKAND':                   'timezone.Asia/Samarkand',
    'ASIA/SEOUL':                       'timezone.Asia/Seoul',
    'ASIA/SHANGHAI':                    'timezone.Asia/Shanghai',
    'ASIA/SINGAPORE':                   'timezone.Asia/Singapore',
    'ASIA/SREDNEKOLYMSK':               'timezone.Asia/Srednekolymsk',
    'ASIA/TAIPEI':                      'timezone.Asia/Taipei',
    'ASIA/TASHKENT':                    'timezone.Asia/Tashkent',
    'ASIA/TBILISI':                     'timezone.Asia/Tbilisi',
    'ASIA/TEHRAN':                      'timezone.Asia/Tehran',
    'ASIA/TEL_AVIV':                    'timezone.Asia/Tel_Aviv',
    'ASIA/THIMBU':                      'timezone.Asia/Thimbu',
    'ASIA/THIMPHU':                     'timezone.Asia/Thimphu',
    'ASIA/TOKYO':                       'timezone.Asia/Tokyo',
    'ASIA/TOMSK':                       'timezone.Asia/Tomsk',
    'ASIA/UJUNG_PANDANG':               'timezone.Asia/Ujung_Pandang',
    'ASIA/ULAANBAATAR':                 'timezone.Asia/Ulaanbaatar',
    'ASIA/ULAN_BATOR':                  'timezone.Asia/Ulan_Bator',
    'ASIA/URUMQI':                      'timezone.Asia/Urumqi',
    'ASIA/UST-NERA':                    'timezone.Asia/Ust-Nera',
    'ASIA/VIENTIANE':                   'timezone.Asia/Vientiane',
    'ASIA/VLADIVOSTOK':                 'timezone.Asia/Vladivostok',
    'ASIA/YAKUTSK':                     'timezone.Asia/Yakutsk',
    'ASIA/YANGON':                      'timezone.Asia/Yangon',
    'ASIA/YEKATERINBURG':               'timezone.Asia/Yekaterinburg',
    'ASIA/YEREVAN':                     'timezone.Asia/Yerevan',
    'ATLANTIC/AZORES':                  'timezone.Atlantic/Azores',
    'ATLANTIC/BERMUDA':                 'timezone.Atlantic/Bermuda',
    'ATLANTIC/CANARY':                  'timezone.Atlantic/Canary',
    'ATLANTIC/CAPE_VERDE':              'timezone.Atlantic/Cape_Verde',
    'ATLANTIC/FAEROE':                  'timezone.Atlantic/Faeroe',
    'ATLANTIC/FAROE':                   'timezone.Atlantic/Faroe',
    'ATLANTIC/JAN_MAYEN':               'timezone.Atlantic/Jan_Mayen',
    'ATLANTIC/MADEIRA':                 'timezone.Atlantic/Madeira',
    'ATLANTIC/REYKJAVIK':               'timezone.Atlantic/Reykjavik',
    'ATLANTIC/SOUTH_GEORGIA':           'timezone.Atlantic/South_Georgia',
    'ATLANTIC/ST_HELENA':               'timezone.Atlantic/St_Helena',
    'ATLANTIC/STANLEY':                 'timezone.Atlantic/Stanley',
    'AUSTRALIA/ACT':                    'timezone.Australia/ACT',
    'AUSTRALIA/ADELAIDE':               'timezone.Australia/Adelaide',
    'AUSTRALIA/BRISBANE':               'timezone.Australia/Brisbane',
    'AUSTRALIA/BROKEN_HILL':            'timezone.Australia/Broken_Hill',
    'AUSTRALIA/CANBERRA':               'timezone.Australia/Canberra',
    'AUSTRALIA/CURRIE':                 'timezone.Australia/Currie',
    'AUSTRALIA/DARWIN':                 'timezone.Australia/Darwin',
    'AUSTRALIA/EUCLA':                  'timezone.Australia/Eucla',
    'AUSTRALIA/HOBART':                 'timezone.Australia/Hobart',
    'AUSTRALIA/LHI':                    'timezone.Australia/LHI',
    'AUSTRALIA/LINDEMAN':               'timezone.Australia/Lindeman',
    'AUSTRALIA/LORD_HOWE':              'timezone.Australia/Lord_Howe',
    'AUSTRALIA/MELBOURNE':              'timezone.Australia/Melbourne',
    'AUSTRALIA/NORTH':                  'timezone.Australia/North',
    'AUSTRALIA/NSW':                    'timezone.Australia/NSW',
    'AUSTRALIA/PERTH':                  'timezone.Australia/Perth',
    'AUSTRALIA/QUEENSLAND':             'timezone.Australia/Queensland',
    'AUSTRALIA/SOUTH':                  'timezone.Australia/South',
    'AUSTRALIA/SYDNEY':                 'timezone.Australia/Sydney',
    'AUSTRALIA/TASMANIA':               'timezone.Australia/Tasmania',
    'AUSTRALIA/VICTORIA':               'timezone.Australia/Victoria',
    'AUSTRALIA/WEST':                   'timezone.Australia/West',
    'AUSTRALIA/YANCOWINNA':             'timezone.Australia/Yancowinna',
    'BRAZIL/ACRE':                      'timezone.Brazil/Acre',
    'BRAZIL/DENORONHA':                 'timezone.Brazil/DeNoronha',
    'BRAZIL/EAST':                      'timezone.Brazil/East',
    'BRAZIL/WEST':                      'timezone.Brazil/West',
    'CANADA/ATLANTIC':                  'timezone.Canada/Atlantic',
    'CANADA/CENTRAL':                   'timezone.Canada/Central',
    'CANADA/EASTERN':                   'timezone.Canada/Eastern',
    'CANADA/MOUNTAIN':                  'timezone.Canada/Mountain',
    'CANADA/NEWFOUNDLAND':              'timezone.Canada/Newfoundland',
    'CANADA/PACIFIC':                   'timezone.Canada/Pacific',
    'CANADA/SASKATCHEWAN':              'timezone.Canada/Saskatchewan',
    'CANADA/YUKON':                     'timezone.Canada/Yukon',
    'CHILE/CONTINENTAL':                'timezone.Chile/Continental',
    'CHILE/EASTERISLAND':               'timezone.Chile/EasterIsland',
    'ETC/GMT':                          'timezone.Etc/GMT',
    'ETC/GREENWICH':                    'timezone.Etc/Greenwich',
    'ETC/UCT':                          'timezone.Etc/UCT',
    'ETC/UNIVERSAL':                    'timezone.Etc/Universal',
    'ETC/UTC':                          'timezone.Etc/UTC',
    'ETC/ZULU':                         'timezone.Etc/Zulu',
    'EUROPE/AMSTERDAM':                 'timezone.Europe/Amsterdam',
    'EUROPE/ANDORRA':                   'timezone.Europe/Andorra',
    'EUROPE/ASTRAKHAN':                 'timezone.Europe/Astrakhan',
    'EUROPE/ATHENS':                    'timezone.Europe/Athens',
    'EUROPE/BELFAST':                   'timezone.Europe/Belfast',
    'EUROPE/BELGRADE':                  'timezone.Europe/Belgrade',
    'EUROPE/BERLIN':                    'timezone.Europe/Berlin',
    'EUROPE/BRATISLAVA':                'timezone.Europe/Bratislava',
    'EUROPE/BRUSSELS':                  'timezone.Europe/Brussels',
    'EUROPE/BUCHAREST':                 'timezone.Europe/Bucharest',
    'EUROPE/BUDAPEST':                  'timezone.Europe/Budapest',
    'EUROPE/BUSINGEN':                  'timezone.Europe/Busingen',
    'EUROPE/CHISINAU':                  'timezone.Europe/Chisinau',
    'EUROPE/COPENHAGEN':                'timezone.Europe/Copenhagen',
    'EUROPE/DUBLIN':                    'timezone.Europe/Dublin',
    'EUROPE/GIBRALTAR':                 'timezone.Europe/Gibraltar',
    'EUROPE/GUERNSEY':                  'timezone.Europe/Guernsey',
    'EUROPE/HELSINKI':                  'timezone.Europe/Helsinki',
    'EUROPE/ISLE_OF_MAN':               'timezone.Europe/Isle_of_Man',
    'EUROPE/ISTANBUL':                  'timezone.Europe/Istanbul',
    'EUROPE/JERSEY':                    'timezone.Europe/Jersey',
    'EUROPE/KALININGRAD':               'timezone.Europe/Kaliningrad',
    'EUROPE/KIEV':                      'timezone.Europe/Kiev',
    'EUROPE/KIROV':                     'timezone.Europe/Kirov',
    'EUROPE/KYIV':                      'timezone.Europe/Kyiv',
    'EUROPE/LISBON':                    'timezone.Europe/Lisbon',
    'EUROPE/LJUBLJANA':                 'timezone.Europe/Ljubljana',
    'EUROPE/LONDON':                    'timezone.Europe/London',
    'EUROPE/LUXEMBOURG':                'timezone.Europe/Luxembourg',
    'EUROPE/MADRID':                    'timezone.Europe/Madrid',
    'EUROPE/MALTA':                     'timezone.Europe/Malta',
    'EUROPE/MARIEHAMN':                 'timezone.Europe/Mariehamn',
    'EUROPE/MINSK':                     'timezone.Europe/Minsk',
    'EUROPE/MONACO':                    'timezone.Europe/Monaco',
    'EUROPE/MOSCOW':                    'timezone.Europe/Moscow',
    'EUROPE/NICOSIA':                   'timezone.Europe/Nicosia',
    'EUROPE/OSLO':                      'timezone.Europe/Oslo',
    'EUROPE/PARIS':                     'timezone.Europe/Paris',
    'EUROPE/PODGORICA':                 'timezone.Europe/Podgorica',
    'EUROPE/PRAGUE':                    'timezone.Europe/Prague',
    'EUROPE/RIGA':                      'timezone.Europe/Riga',
    'EUROPE/ROME':                      'timezone.Europe/Rome',
    'EUROPE/SAMARA':                    'timezone.Europe/Samara',
    'EUROPE/SAN_MARINO':                'timezone.Europe/San_Marino',
    'EUROPE/SARAJEVO':                  'timezone.Europe/Sarajevo',
    'EUROPE/SARATOV':                   'timezone.Europe/Saratov',
    'EUROPE/SIMFEROPOL':                'timezone.Europe/Simferopol',
    'EUROPE/SKOPJE':                    'timezone.Europe/Skopje',
    'EUROPE/SOFIA':                     'timezone.Europe/Sofia',
    'EUROPE/STOCKHOLM':                 'timezone.Europe/Stockholm',
    'EUROPE/TALLINN':                   'timezone.Europe/Tallinn',
    'EUROPE/TIRANE':                    'timezone.Europe/Tirane',
    'EUROPE/TIRASPOL':                  'timezone.Europe/Tiraspol',
    'EUROPE/ULYANOVSK':                 'timezone.Europe/Ulyanovsk',
    'EUROPE/UZHGOROD':                  'timezone.Europe/Uzhgorod',
    'EUROPE/VADUZ':                     'timezone.Europe/Vaduz',
    'EUROPE/VATICAN':                   'timezone.Europe/Vatican',
    'EUROPE/VIENNA':                    'timezone.Europe/Vienna',
    'EUROPE/VILNIUS':                   'timezone.Europe/Vilnius',
    'EUROPE/VOLGOGRAD':                 'timezone.Europe/Volgograd',
    'EUROPE/WARSAW':                    'timezone.Europe/Warsaw',
    'EUROPE/ZAGREB':                    'timezone.Europe/Zagreb',
    'EUROPE/ZAPOROZHYE':                'timezone.Europe/Zaporozhye',
    'EUROPE/ZURICH':                    'timezone.Europe/Zurich',
    'INDIAN/ANTANANARIVO':              'timezone.Indian/Antananarivo',
    'INDIAN/CHAGOS':                    'timezone.Indian/Chagos',
    'INDIAN/CHRISTMAS':                 'timezone.Indian/Christmas',
    'INDIAN/COCOS':                     'timezone.Indian/Cocos',
    'INDIAN/COMORO':                    'timezone.Indian/Comoro',
    'INDIAN/KERGUELEN':                 'timezone.Indian/Kerguelen',
    'INDIAN/MAHE':                      'timezone.Indian/Mahe',
    'INDIAN/MALDIVES':                  'timezone.Indian/Maldives',
    'INDIAN/MAURITIUS':                 'timezone.Indian/Mauritius',
    'INDIAN/MAYOTTE':                   'timezone.Indian/Mayotte',
    'INDIAN/REUNION':                   'timezone.Indian/Reunion',
    'MEXICO/BAJANORTE':                 'timezone.Mexico/BajaNorte',
    'MEXICO/BAJASUR':                   'timezone.Mexico/BajaSur',
    'MEXICO/GENERAL':                   'timezone.Mexico/General',
    'PACIFIC/APIA':                     'timezone.Pacific/Apia',
    'PACIFIC/AUCKLAND':                 'timezone.Pacific/Auckland',
    'PACIFIC/BOUGAINVILLE':             'timezone.Pacific/Bougainville',
    'PACIFIC/CHATHAM':                  'timezone.Pacific/Chatham',
    'PACIFIC/CHUUK':                    'timezone.Pacific/Chuuk',
    'PACIFIC/EASTER':                   'timezone.Pacific/Easter',
    'PACIFIC/EFATE':                    'timezone.Pacific/Efate',
    'PACIFIC/ENDERBURY':                'timezone.Pacific/Enderbury',
    'PACIFIC/FAKAOFO':                  'timezone.Pacific/Fakaofo',
    'PACIFIC/FIJI':                     'timezone.Pacific/Fiji',
    'PACIFIC/FUNAFUTI':                 'timezone.Pacific/Funafuti',
    'PACIFIC/GALAPAGOS':                'timezone.Pacific/Galapagos',
    'PACIFIC/GAMBIER':                  'timezone.Pacific/Gambier',
    'PACIFIC/GUADALCANAL':              'timezone.Pacific/Guadalcanal',
    'PACIFIC/GUAM':                     'timezone.Pacific/Guam',
    'PACIFIC/HONOLULU':                 'timezone.Pacific/Honolulu',
    'PACIFIC/JOHNSTON':                 'timezone.Pacific/Johnston',
    'PACIFIC/KANTON':                   'timezone.Pacific/Kanton',
    'PACIFIC/KIRITIMATI':               'timezone.Pacific/Kiritimati',
    'PACIFIC/KOSRAE':                   'timezone.Pacific/Kosrae',
    'PACIFIC/KWAJALEIN':                'timezone.Pacific/Kwajalein',
    'PACIFIC/MAJURO':                   'timezone.Pacific/Majuro',
    'PACIFIC/MARQUESAS':                'timezone.Pacific/Marquesas',
    'PACIFIC/MIDWAY':                   'timezone.Pacific/Midway',
    'PACIFIC/NAURU':                    'timezone.Pacific/Nauru',
    'PACIFIC/NIUE':                     'timezone.Pacific/Niue',
    'PACIFIC/NORFOLK':                  'timezone.Pacific/Norfolk',
    'PACIFIC/NOUMEA':                   'timezone.Pacific/Noumea',
    'PACIFIC/PAGO_PAGO':                'timezone.Pacific/Pago_Pago',
    'PACIFIC/PALAU':                    'timezone.Pacific/Palau',
    'PACIFIC/PITCAIRN':                 'timezone.Pacific/Pitcairn',
    'PACIFIC/POHNPEI':                  'timezone.Pacific/Pohnpei',
    'PACIFIC/PONAPE':                   'timezone.Pacific/Ponape',
    'PACIFIC/PORT_MORESBY':             'timezone.Pacific/Port_Moresby',
    'PACIFIC/RAROTONGA':                'timezone.Pacific/Rarotonga',
    'PACIFIC/SAIPAN':                   'timezone.Pacific/Saipan',
    'PACIFIC/SAMOA':                    'timezone.Pacific/Samoa',
    'PACIFIC/TAHITI':                   'timezone.Pacific/Tahiti',
    'PACIFIC/TARAWA':                   'timezone.Pacific/Tarawa',
    'PACIFIC/TONGATAPU':                'timezone.Pacific/Tongatapu',
    'PACIFIC/TRUK':                     'timezone.Pacific/Truk',
    'PACIFIC/WAKE':                     'timezone.Pacific/Wake',
    'PACIFIC/WALLIS':                   'timezone.Pacific/Wallis',
    'PACIFIC/YAP':                      'timezone.Pacific/Yap',
    'US/ALASKA':                        'timezone.US/Alaska',
    'US/ALEUTIAN':                      'timezone.US/Aleutian',
    'US/ARIZONA':                       'timezone.US/Arizona',
    'US/CENTRAL':                       'timezone.US/Central',
    'US/EAST-INDIANA':                  'timezone.US/East-Indiana',
    'US/EASTERN':                       'timezone.US/Eastern',
    'US/HAWAII':                        'timezone.US/Hawaii',
    'US/INDIANA-STARKE':                'timezone.US/Indiana-Starke',
    'US/MICHIGAN':                      'timezone.US/Michigan',
    'US/MOUNTAIN':                      'timezone.US/Mountain',
    'US/PACIFIC':                       'timezone.US/Pacific',
    'US/SAMOA':                         'timezone.US/Samoa',
  },
  TYPE: {
    ACCOUNT: {
      CUSTOMER:     'type.account.customer',
      PRIVATELABEL: 'type.account.privatelabel',
      SYSTEM:       'type.account.system',
    },
    ASSET: {
      FILE:  'type.asset.file',
      FORM:  'type.asset.form',
      IMAGE: 'type.asset.image',
    },
    CAMPAIGN_MONITOR: {
      AGENCY: 'type.campaignmonitor.agency',
      DIRECT: 'type.campaignmonitor.direct',
    },
    CAMPAIGNOBJECT: {
      ALL:        'type.campaignobject.all',
      CONTENT:    'type.campaignobject.content',
      CONTEST:    'type.campaignobject.contest',
      COUPON:     'type.campaignobject.coupon',
      CUSTOM:     'type.campaignobject.custom',
      DOWNLOAD:   'type.campaignobject.download',
      GAME:       'type.campaignobject.game',
      GOAL:       'type.campaignobject.goal',
      LOYALTY:    'type.campaignobject.loyalty',
      PROMOTION:  'type.campaignobject.promotion',
      QUIZ:       'type.campaignobject.quiz',
      REVEAL:     'type.campaignobject.reveal',
      SIGNUP:     'type.campaignobject.signup',
      SOCIAL:     'type.campaignobject.social',
      SWEEPSTAKE: 'type.campaignobject.sweepstake',
    },
    CAMPAIGNPROMOTION: {
      REVEAL: 'type.campaignpromotion.reveal',
      REWARD: 'type.campaignpromotion.reward',
    },
    CHANNEL: {
      FACEBOOK:  'type.channel.facebook',
      INSTAGRAM: 'type.channel.instagram',
      SNAPCHAT:  'type.channel.snapchat',
      TWITTER:   'type.channel.twitter',
      WEB:       'type.channel.web',
    },
    DESTINATION: {
      INSTAGRAM: 'type.destination.instagram',
      MICROSITE: 'type.destination.microsite',
      OVERLAY:   'type.destination.overlay',
      STORY:     'type.destination.story',
      WEB:       'type.destination.web',
    },
    DISPLAYCONTAINER: {
      EMBED:  'type.displaycontainer.embed',
      SINGLE: 'type.displaycontainer.single',
    },
    DISPLAYCONTAINER_FACEBOOK: { STORY: 'type.displaycontainer.facebook.story' },
    DISPLAYCONTAINER_FB:       {
      CANVAS: 'type.displaycontainer.fb.canvas',
      PAGE:   'type.displaycontainer.fb.page',
    },
    DISPLAYCONTAINER_INSTAGRAM: {
      INNETWORK: 'type.displaycontainer.instagram.innetwork',
      STORY:     'type.displaycontainer.instagram.story',
    },
    DISPLAYCONTAINER_SNAPCHAT: { STORY: 'type.displaycontainer.snapchat.story' },
    DISPLAYCONTAINER_TWITTER:  {
      INNETWORK: 'type.displaycontainer.twitter.innetwork',
      STORY:     'type.displaycontainer.twitter.story',
    },
    DISPLAYCONTAINER_WEB: {
      EMBED:     'type.displaycontainer.web.embed',
      MICROSITE: 'type.displaycontainer.web.microsite',
      OVERLAY:   'type.displaycontainer.web.overlay',
      WEB:       'type.displaycontainer.web.story',
    },
    DISPLAYOBJECT: {
      CUSTOM:   'type.displayobject.custom',
      DEFAULT:  'type.displayobject.default',
      MODULE:   'type.displayobject.module',
      MULTIPLE: 'type.displayobject.multiple',
      PAGE:     'type.displayobject.page',
      SINGLE:   'type.displayobject.single',
      STREAM:   'type.displayobject.stream',
    },
    DISPLAYUNIT: {
      BANNER:            'type.displayunit.banner',
      FACEBOOKTABSTREAM: 'type.displayunit.facebooktabstream',
      FEATURE:           'type.displayunit.feature',
      FEATUREBAR:        'type.displayunit.featureBar',
      FULLSCREENSTREAM:  'type.displayunit.fullscreenstream',
      HERO:              'type.displayunit.hero',
      HEROSTREAM:        'type.displayunit.herostream',
      NEXTBESTACTION:    'type.displayunit.nextbestaction',
      PROMOTION:         'type.displayunit.promotion',
      RICHHERO:          'type.displayunit.richHero',
      SIDEBAR:           'type.displayunit.sidebar',
      SIDEBARSTREAM:     'type.displayunit.sidebarstream',
      SKYSCRAPER:        'type.displayunit.skyscraper',
      TAKEOVERSTREAM:    'type.displayunit.takeoverstream',
    },
    DISPLAYUNIT_FACEBOOK: {
      STORY: 'type.displayunit.facebook.story',
      PAGE:  'type.displayunit.fb.page',
    },
    DISPLAYUNIT_INSTAGRAM: { STORY: 'type.displayunit.instagram.story' },
    DISPLAYUNIT_SNAPCHAT:  { STORY: 'type.displayunit.snapchat.story' },
    DISPLAYUNIT_TWITTER:   { STORY: 'type.displayunit.twitter.story' },
    DISPLAYUNIT_WEB:       {
      EMBED:     'type.displayunit.web.embed',
      MICROSITE: 'type.displayunit.web.microsite',
      OVERLAY:   'type.displayunit.web.overlay',
    },
    EVENT: {
      ENGAGEMENT:   'type.event.engagement',
      ESENGAGEMENT: 'type.event.esengagement',
      ESVIRALITY:   'type.event.esvirality',
      GOAL:         'type.event.goal',
      REACH:        'type.event.reach',
    },
    EXPORT: {
      CAMPAIGNLEADS:           'type.export.campaignleads',
      CODECAMPAIGNREDEMPTIONS: 'type.export.codecampaignredemptions',
      COLLECTION:              'type.export.collection',
      WINNERS:                 'type.export.winners',
    },
    EXPORT_PARTITION: {
      ENTRY:      'type.export.partition.entry',
      REDEMPTION: 'type.export.partition.redemption',
      WINNER:     'type.export.partition.winner',
    },
    FORM: {
      CONTEST:     'type.form.contest',
      COUPON:      'type.form.coupon',
      CUSTOM:      'type.form.custom',
      DOWNLOAD:    'type.form.download',
      GAME:        'type.form.game',
      GENERIC:     'type.form.generic',
      QUIZ:        'type.form.quiz',
      REVEAL:      'type.form.reveal',
      SIGNUP:      'type.form.signup',
      COMPETITION: 'type.form.sweepstake',
    },
    INTEGRATION: {
      ADOBECOMMERCEEXTDATA:    'type.integration.adobecommerceextdata',
      ADOBEHTTP:               'type.integration.adobehttp',
      ADOBELAUNCH:             'type.integration.adobelaunch',
      ARSENALIDCHECK:          'type.integration.arsenalidcheck',
      BATNORDICS:              'type.integration.batnordics',
      BLUESHIFT:               'type.integration.blueshift',
      BRONTO:                  'type.integration.bronto',
      BVREVIEW:                'type.integration.bvreview',
      CAMPAIGNMONITOR:         'type.integration.campaignmonitor',
      CHEETAH_CHEETAHMAIL:     'type.integration.cheetah.cheetahmail',
      CHEETAH_EDP:             'type.integration.cheetah.edp',
      CHEETAH_MESSAGING:       'type.integration.cheetah.messaging',
      CHEETAH_MESSAGINGVERIFY: 'type.integration.cheetah.messagingverify',
      CODEGATE:                'type.integration.codegate',
      CPV:                     'type.integration.cpv',
      DRIIVN:                  'type.integration.driivn',
      EMAIL:                   'type.integration.email',
      EMMA:                    'type.integration.emma',
      EPSILON:                 'type.integration.epsilon',
      EPSILONSURVEY:           'type.integration.epsilonsurvey',
      EXACTTARGET:             'type.integration.exacttarget',
      GOOGLEANALYTICS:         'type.integration.ga',
      GCP:                     'type.integration.gcp',
      GIGYA:                   'type.integration.gigya',
      GIGYALITE:               'type.integration.gigyalite',
      GRS:                     'type.integration.grs',
      GOOGLETAGMANAGER:        'type.integration.gtm',
      GUMA:                    'type.integration.guma',
      HIVECODE:                'type.integration.hivecode',
      HTTP:                    'type.integration.http',
      HTTPVERIFY:              'type.integration.httpverify',
      IMICAMPAIGN:             'type.integration.imicampaign',
      JANRAIN:                 'type.integration.janrain',
      KELLOGGSEPSILONSURVEY:   'type.integration.kelloggsepsilonsurvey',
      KRAFTHEINZ:              'type.integration.kraftheinz',
      LEADERBOARD:             'type.integration.leaderboard',
      MAILCHIMP:               'type.integration.mailchimp',
      MAPPUSER:                'type.integration.mappuser',
      MARKETO:                 'type.integration.marketo',
      MIXCODE:                 'type.integration.mixcode',
      ONLOADHTTP:              'type.integration.onloadhttp',
      OPENIDONLOAD:            'type.integration.openidonload',
      PEPSIMAPP:               'type.integration.pepsimapp',
      PESPROFILE:              'type.integration.pesprofile',
      PEXELS:                  'type.integration.pexels',
      QUICKEN:                 'type.integration.quicken',
      SAILTHRU:                'type.integration.sailthru',
      SAILTHRUSELFSERVE:       'type.integration.sailthruselfserve',
      SALESFORCE:              'type.integration.salesforce',
      SCRIPPSMAIL:             'type.integration.scrippsmail',
      SCRIPPSNOTIFY:           'type.integration.scrippsnotify',
      SELLIGENT:               'type.integration.selligent',
      SHOPIFYEXTDATA:          'type.integration.shopifyextdata',
      SNINOTIFY:               'type.integration.sninotify',
      THREESIXTY:              'type.integration.threesixty',
      TREASURYWINES:           'type.integration.treasurywines',
      UNILEVERPUSH:            'type.integration.unileverpush',
      WATSON:                  'type.integration.watson',
      WHITELABELLOYALTY:       'type.integration.whitelabelloyalty',
      ZAPPIT:                  'type.integration.zappit',
    },
    INTEGRATIONAPPLICATION: {
      ADOBECOMMERCE:     'type.integrationapplication.adobecommerce',
      CAMPAIGNMONITOR:   'type.integrationapplication.campaignmonitor',
      EMMA:              'type.integrationapplication.emma',
      MOMENTS:           'type.integrationapplication.moments',
      OPENIDONLOAD:      'type.integrationapplication.openidonload',
      SAILTHRUSELFSERVE: 'type.integrationapplication.sailthruselfserve',
      SHOPIFYEXTDATA:    'type.integrationapplication.shopifyextdata',
    },
    POLICY: {
      CHECKBOX:     'type.policy.checkbox',
      FOOTER:       'type.policy.footer',
      NOTIFICATION: 'type.policy.notification',
    },
    STOREAPP: {
      EXPERIENCE:  'type.storeapp.experience',
      SVCSPACKAGE: 'type.storeapp.svcspackage',
    },
    THEME: {
      CSS:  'type.theme.css',
      FLEX: 'type.theme.flex',
      LESS: 'type.theme.less',
      SASS: 'type.theme.sass',
      WEB:  'type.theme.web',
    },
    USER: { STANDARD: 'type.user.standard' },
  },
  SUBTYPE: {
    CAMPAIGNOBJECT: {
      CONTENTBRAND:                    'type.campaignobject.content.brand',
      CONTENTLIVEEVENT:                'type.campaignobject.content.liveevent',
      CONTENTPAGE:                     'type.campaignobject.content.page',
      CONTENTPHOTOGALLERY:             'type.campaignobject.content.photogallery',
      CONTENTVIODEOGALERY:             'type.campaignobject.content.videogallery',
      CONTESTCAPTION:                  'type.campaignobject.contest.caption',
      CONTESTFAVOURITE:                'type.campaignobject.contest.favourite',
      CONTESTPHOTO:                    'type.campaignobject.contest.photo',
      CONTESTVIDEO:                    'type.campaignobject.contest.video',
      COUPONCODE:                      'type.campaignobject.coupon.code',
      COUPONEXTCODES:                  'type.campaignobject.coupon.extcodes',
      COUPONLINK:                      'type.campaignobject.coupon.link',
      COUPONPRINT:                     'type.campaignobject.coupon.print',
      DOWNLOADASSET:                   'type.campaignobject.download.asset',
      SPINTHEWHEEL:                    'type.campaignobject.game.spinthewheel',
      GOALMILESTONES:                  'type.campaignobject.goal.milestones',
      LOYALTYPROGRAMME:                'type.campaignobject.loyalty.programme',
      PROMOTIONCLICK:                  'type.campaignobject.promotion.click',
      PROMOTIONOFFER:                  'type.campaignobject.promotion.offer',
      QUIZADOBECOMMERCE:               'type.campaignobject.quiz.adobecommerce',
      QUIZCATEGORY:                    'type.campaignobject.quiz.category',
      QUIZCATEGORYCHATBOT:             'type.campaignobject.quiz.categorychatbot',
      QUIZINTERVAL:                    'type.campaignobject.quiz.interval',
      QUIZQUICKFIRE:                   'type.campaignobject.quiz.quickfire',
      QUIZSCORE:                       'type.campaignobject.quiz.score',
      QUIZSHOPIFY:                     'type.campaignobject.quiz.shopify',
      QUIZVS:                          'type.campaignobject.quiz.vs',
      REVEALADVENTCALENDAR:            'type.campaignobject.reveal.adventcalendar',
      REVEALCOUNTDOWN:                 'type.campaignobject.reveal.countdown',
      MICROADVENTCALENDAR:             'type.campaignobject.reveal.microadventcalendar',
      SIGNUPEVENT:                     'type.campaignobject.signup.event',
      SIGNUPFEEDBACK:                  'type.campaignobject.signup.feedback',
      SIGNUPLANDING:                   'type.campaignobject.signup.landing',
      SIGNUPNEWSLETTER:                'type.campaignobject.signup.newsletter',
      SIGNUPPRODUCT:                   'type.campaignobject.signup.product',
      SIGNUPREGISTRATION:              'type.campaignobject.signup.registration',
      SIGNUPSAMPLE:                    'type.campaignobject.signup.sample',
      SOCIALCONTENT:                   'type.campaignobject.social.content',
      SOCIALDATA:                      'type.campaignobject.social.data',
      SOCIALEVENT:                     'type.campaignobject.social.event',
      SOCIALHASHTAG:                   'type.campaignobject.social.hashtag',
      SWEEPSTAKECAPTION:               'type.campaignobject.sweepstake.caption',
      SWEEPSTAKEGIVEAWAY:              'type.campaignobject.sweepstake.giveaway',
      SWEEPSTAKEINSTAGRAM:             'type.campaignobject.sweepstake.instagram',
      SWEEPSTAKEINSTANTWIN:            'type.campaignobject.sweepstake.instantwin',
      SWEEPSTAKEMULTINETWORKCLAIMFORM: 'type.campaignobject.sweepstake.multinetwork.claimform',
      SWEEPSTAKEMULTINETWORKENTRYFORM: 'type.campaignobject.sweepstake.multinetwork.entryform',
      SWEEPSTAKEMULTINETWORKNOFORM:    'type.campaignobject.sweepstake.multinetwork.noform',
      SWEEPSTAKEPHOTO:                 'type.campaignobject.sweepstake.photo',
      SWEEPSTAKESKILL:                 'type.campaignobject.sweepstake.skill',
      SWEEPSTAKETWITTER:               'type.campaignobject.sweepstake.twitter',
    },
  },
};
// *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** ***
// *** *** DO NOT MODIFY. THIS IS A GENERATED FILE...KITTENS COULD DIE *** ***
// *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** ***
